import { addDays, format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export type WeekendHit = {
  date: string;
  sessionIndex: number;
  weekdayLabel: 'sábado' | 'domingo';
  formatted: string;
};

export function ymdToLocalDate(ymd: string): Date {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
}

export function addDaysToYmd(ymd: string, days: number): string {
  return format(addDays(ymdToLocalDate(ymd), days), 'yyyy-MM-dd');
}

/** Move a data para o próximo dia da semana alvo (0=dom … 6=sáb), na mesma semana civil quando possível. */
export function shiftDateToWeekday(ymd: string, targetWeekday: number): string {
  const tw = Math.floor(targetWeekday);
  if (tw < 0 || tw > 6) return ymd;
  const current = ymdToLocalDate(ymd).getDay();
  const delta = (tw - current + 7) % 7;
  return addDaysToYmd(ymd, delta);
}

/** Datas de início de cada sessão: início + (i × intervalo em dias). */
export function buildRecurringAppointmentDates(
  startYmd: string,
  sessionCount: number,
  intervalDays: number,
): string[] {
  const count = Math.max(1, Math.min(52, Math.floor(sessionCount)));
  const step = Math.max(1, Math.min(365, Math.floor(intervalDays)));
  const dates: string[] = [];
  for (let i = 0; i < count; i++) {
    dates.push(addDaysToYmd(startYmd, i * step));
  }
  return dates;
}

export function detectWeekendSessionHits(dates: string[]): WeekendHit[] {
  const hits: WeekendHit[] = [];
  dates.forEach((date, index) => {
    const dow = ymdToLocalDate(date).getDay();
    if (dow !== 0 && dow !== 6) return;
    hits.push({
      date,
      sessionIndex: index + 1,
      weekdayLabel: dow === 0 ? 'domingo' : 'sábado',
      formatted: format(ymdToLocalDate(date), "EEEE, d 'de' MMM", { locale: ptBR }),
    });
  });
  return hits;
}
